var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top slide", class: { up: !_vm.ready } },
    [
      _c("div", { staticClass: "cart-controls" }, [
        _c("small", [_vm._v(_vm._s(_vm.shown) + "/" + _vm._s(_vm.total))]),
        _vm._v(" "),
        _c(
          "button",
          {
            attrs: {
              "data-tooltip": _vm.i18n.orders.random,
              disabled: _vm.shown === 0
            },
            on: { click: _vm.orderRandom }
          },
          [_c("span", { staticClass: "icon icon-random" })]
        ),
        _vm._v(" "),
        _c("button", { on: { click: _vm.toggleOrders } }, [
          _c("span", { staticClass: "icon icon-orders" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.ordered))])
        ])
      ]),
      _vm._v(" "),
      _c("filters")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-148607c7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148607c7","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/components/top-bar/top-bar.html
// module id = 145
// module chunks = 0